import { useRef } from 'react'
import { Text } from 'react-native-paper'
import { useTranslation } from 'react-i18next'
import Toast from 'react-native-root-toast'
import * as Sentry from '@sentry/react-native'
import { MessageType } from '../../../../utils/message-type'
import { MelddButton } from '../../../../@ui'
import {
  ConfirmDialogue,
  ConfirmDialogueRef,
} from '../../../../@ui/containers/modals/confirm.dialogue'
import {
  useDowngradeNodeTierMutation,
  DowngradeNodeTierInput,
} from '../../../../generated/graphql'

interface DowngradeNodeTierButtonProps {
  nodeTierId: string
  seats: number
  disabled?: boolean
  onDowngradeSuccess?: () => void
}

export const DowngradeNodeTierButton = ({
  nodeTierId,
  seats,
  disabled,
  onDowngradeSuccess,
}: DowngradeNodeTierButtonProps) => {
  const { t } = useTranslation('tiers')
  const confirmDialogRef = useRef<ConfirmDialogueRef>(null)
  const [downgradeNodeTier, { loading }] = useDowngradeNodeTierMutation()

  const handleDowngrade = async () => {
    try {
      const input: DowngradeNodeTierInput = {
        nodeTierId,
        seats,
      }

      const result = await downgradeNodeTier({
        variables: { input },
      })

      if (result.data?.downgradeNodeTier) {
        Toast.show(t('node-tier-downgrade-initiated'), MessageType.info)
        onDowngradeSuccess?.()
      }
    } catch (error) {
      console.error('Error downgrading node tier:', error)
      Sentry.captureException(error)
      Toast.show(t('error-downgrading-node-tier'), MessageType.error)
      return false
    }
  }

  return (
    <>
      <MelddButton
        onPress={() => confirmDialogRef.current?.open()}
        title={t('downgrade')}
        isDisabled={loading || disabled}
      />
      <ConfirmDialogue
        ref={confirmDialogRef}
        label={t('downgrade-node-tier-title')}
        onContinue={handleDowngrade}
        acceptLabel={t('downgrade')}
        cancelLabel={t('cancel')}
      >
        <Text>{t('downgrade-node-tier-message')}</Text>
      </ConfirmDialogue>
    </>
  )
}
